export default __webpack_public_path__ + "static/media/DailyProductionIconYellow.d16f4f40.png";